module.exports = require("@swa-ui/core/src/CenterToWindow/CenterToWindow.module.scss");